module.exports = __webpack_public_path__ + "img/UTHYRU-5.130a12f4.jpg";